export const environment = {
    production: true,
    region: 'us-east-1',
    userPoolId: 'us-east-1_1tNrSXyPp',
    userPoolWebClientId: '4c31inte9lu6m9uskn3fr523si',
    env: 'default',
    domain: 'live-auth.checkoutchamp.com'
  };
  
  import 'zone.js/dist/zone-error';
